import React, { useState } from 'react'
import ReactPlayer, { ReactPlayerProps } from 'react-player'
import OrangePlayIcon from '../static/OrangePlayButton.svg'
import SvgIcon from '@mui/material/SvgIcon'
import { useTheme } from '@mui/material/styles'

export interface IVideoPlayer extends ReactPlayerProps {
  previewDimensions?: {
    width: number
    height: number
  }
  videoDimensions?: {
    width: number
    height: number
  }
}

export const VideoPlayer = ({ previewDimensions, videoDimensions, ...props }: IVideoPlayer) => {
  const { shape } = useTheme()
  const styles = {
    videoPlayer: {
      maxWidth: '100%',
      transition: 'all ease-in-out 500ms',
      '&>video': {
        borderRadius: shape.borderRadius,
      },
    },
    videoPlayerIcon: {
      position: 'absolute',
      height: 45,
      width: 45,
    },
  }
  const hasPreview = !!props.light
  const initialDimensions = hasPreview ? previewDimensions : videoDimensions
  const defaultDimensions = hasPreview ? { width: 300, height: 300 } : { width: 640, height: 'auto' }

  const [width, setWidth] = useState(initialDimensions?.width || defaultDimensions.width)
  const [height, setHeight] = useState(initialDimensions?.height || defaultDimensions.height)

  return (
    <ReactPlayer
      width={width}
      height={height}
      style={styles.videoPlayer}
      onClickPreview={() => {
        setHeight(videoDimensions?.height || 'auto')
        setWidth(videoDimensions?.width || 640)
      }}
      playIcon={<SvgIcon component={OrangePlayIcon} viewBox={'0 0 92 96'} sx={styles.videoPlayerIcon} />}
      {...props}
    />
  )
}

export default VideoPlayer
